import React, { Component, SyntheticEvent, useState } from 'react'
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import MuiPhoneNumber from 'material-ui-phone-number'
import { useFirebaseConnect } from 'react-redux-firebase';
import { useMemo } from 'react';
import parsePhoneNumberFromString, { parsePhoneNumber } from 'libphonenumber-js';
import { addPhoneInvite } from '../actions/sharelink.actions';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

const styles = theme => ({
    main: {
      width: 'auto',
      display: 'block', // Fix IE 11 issue.
      marginLeft: theme.spacing.unit * 3,
      marginRight: theme.spacing.unit * 3,
      [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
        width: 400,
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    paper: {
      marginTop: theme.spacing.unit * 8,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
      margin: theme.spacing.unit,
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing.unit,
    },
    submit: {
      marginTop: theme.spacing.unit * 3,
    },
  })

const _DownloadPortal = (props: any) => {
    let params = useParams();
    const query = useQuery()
    const dispatch = useDispatch()

    const { classes } = props





    return (
        <main className={classes.main}>

            <CssBaseline />
            <div style={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'}} >
                <Typography style={{color: '#4286dd', marginBottom: 16}} component="h1" variant="h3">
                    DockPad
                </Typography>

                <Typography style={{ textAlign: 'center', width: '100%', marginBottom: 8 }}>
                    DockPad is a messaging and communication platform for Construction. DockPad connects superintendents, project manangers, trades, and stake holders by connecting text messages, email, and phones with a simple to use system.
                </Typography>
                <Button style={{width: '100%'}} size="large" variant="contained" color="primary"  href="https://apps.apple.com/us/app/dockpad-last-planner/id1532632200">
                    Install for iOS
                </Button>
            </div>

        </main>
    )
}


export const DownloadPortal  = withStyles(styles)(_DownloadPortal)



// WEBPACK FOOTER //
// ./src/containers/DownloadPortal.tsx